import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateLocationOverrideRuleStatus } from '../../../api/plan-location-override-rules-api'
import type { PlanLocationOverrideRuleStatus } from '../enums/plan-location-override-rule.enum'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'
import { LOCATION_OVERRIDE_RULE_QUERY_KEY } from './useGetLocationOverrideRule'

interface Variables {
  id: string
  status: PlanLocationOverrideRuleStatus
}

export function useToggleLocationOverrideRuleStatus() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, Variables>({
    mutationFn: ({ id, status }) =>
      updateLocationOverrideRuleStatus(id, { status }),
    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULE_QUERY_KEY, variables.id],
      })
    },
  })
}
